import axiosClient from "./axios";

// 1. Sinastri isteği gönder
export const postSynastryRequest = async (data) => {
  try {
    const response = await axiosClient.post(`/module/synastry/request`, data);
    return response.data;
  } catch (error) {
    console.error("Sinastri isteği gönderilirken hata:", error);
    throw error;
  }
};

// 2. Sinastri isteğini güncelle (kabul et, reddet, sil)
export const updateSynastryRequest = async (uuid, action) => {
  try {
    const response = await axiosClient.post(`/module/synastry/request/${uuid}/update`, { action });
    return response.data;
  } catch (error) {
    console.error("Sinastri isteği güncellenirken hata:", error);
    throw error;
  }
};

// 3. Sinastri listesi getir
export const getSynastryList = async () => {
  try {
    const response = await axiosClient.get(`/module/synastry/list`);
    return response.data;
  } catch (error) {
    console.error("Sinastri listesi alınırken hata:", error);
    throw error;
  }
};

// 4. Sinastri detayı getir
export const getSynastry = async (uuid) => {
  try {
    const response = await axiosClient.get(`/module/synastry/${uuid}`);
    return response.data;
  } catch (error) {
    console.error("Sinastri detayı alınırken hata:", error);
    throw error;
  }
};

